import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BillingAccountService } from 'src/app/services/BillingAccount/billing-account.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { QuillEditorComponent } from 'ngx-quill';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-send-mail',
  templateUrl: './send-mail.component.html',
  styleUrls: ['./send-mail.component.css']
})
export class SendMailComponent implements OnInit {
  @ViewChildren('hidewhenloading') hidewhenloading: QueryList<ElementRef>;
  quillTxt: any;
  schId: any;
  mailBody: any;
  mailSubject: string;
  modules: any;
  selectedId = 0;
  selectedCode: any;
  name: string;
  isreadonly = false;
  disableButtons = true;
  placeholder = "{candidatename} = Enrolled Candiate Name, {course} = Course Title,  {code} = Course Code";
  constructor(public headerinfo: ComponentheaderService, public schoolservice: SchoolmanagementService,
    public toastr: ToastrService, public moduleservice: ModulemanagementService, private activatedroute: ActivatedRoute,) { }

  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);
    this.headerinfo.setHeaderDisplay('Send Email', [{ displaytext: 'Send Email', route: '/user/sendmail' }], []);
    this.selectedId = this.activatedroute.snapshot.queryParams.moduleId;
    if (this.selectedId) {
      this.checkCourse();
    } else {
      const school: any = await this.schoolservice.getSchoolFromSubdomain();
      this.schId = school.id;
      this.modules = await this.moduleservice.getAllSchoolModule(this.schId).toPromise();
    }

    let draft: any = await this.schoolservice.getMailDraft().toPromise();
    if (draft !== null && draft !== undefined) {
      this.mailSubject = draft.subject;
      this.mailBody = draft.body;
    }

    this.disableButtons = false
    this.headerinfo.pageLoadingDone(this);

  }

  onModuleSelected(id: any) {
    this.selectedCode = null;
    this.selectedId = id;
    this.selectedCode = this.modules.filter(m => m.id == this.selectedId)[0].courseCode;
  }

  async testMail() {
    this.headerinfo.pageLoadingStarted(this);
    this.disableButtons = true;
    if (!this.checkModelValid()) {
      return;
    }
    let data = {
      body: this.mailBody,
      subject: this.mailSubject,
      allStudent: this.selectedId == 0,
      moduleId: this.selectedId,
      schoolId: this.schId
    };

    if (this.selectedId) {
      data.moduleId = this.selectedId;
    }
    await this.schoolservice.sendTestMail(data).toPromise()
      .then((res: any) => { this.toastr.success("An email has been sent to " + res); }).catch((err) => {
        this.toastr.error(err);
        this.disableButtons = false;

        return;
      });

    this.disableButtons = false;
    this.headerinfo.pageLoadingDone(this);
  }

  async sendMail() {
    this.headerinfo.pageLoadingStarted(this);

    this.disableButtons = true;
    if (!this.checkModelValid()) {
      return;
    }
    let data = {
      body: this.mailBody,
      subject: this.mailSubject,
      allStudent: this.selectedId == 0,
      moduleId: 0,
      schoolId: this.schId
    };

    if (this.selectedId) {
      data.moduleId = this.selectedId;
    }
    await this.schoolservice.sendMail(data).toPromise()
      .then(() => { this.toastr.success("Email Sent."); }).catch((err) => {
        this.disableButtons = false;
        this.toastr.error(err);
        return;
      });
    this.disableButtons = false;
    this.headerinfo.pageLoadingDone(this);

  }
  checkModelValid() {
    if (this.mailSubject == '' || this.mailSubject == undefined || this.mailSubject == null) {
      this.toastr.warning("Mail Subject is required");
      this.disableButtons = false;

      return false;
    }

    if (this.mailBody == '' || this.mailBody == undefined || this.mailBody == null) {
      this.toastr.warning("Mail Body is required");
      this.disableButtons = false;
      return false;
    }
    return true;
  }
  async checkCourse() {
    this.modules = [];
    let module: any = await this.moduleservice.getModuleInfo(this.selectedId).toPromise();

    if (module) {
      let newCourse = {
        moduleName: module.name,
        id: module.id
      }
      this.modules.push(newCourse);
      this.schId = module.schoolID;
      this.selectedCode = module.courseCode;
      this.isreadonly = true;
    }

  }
}
